/**
 * Starts loading the web code of the Firestore, Device and Functions
 * plugins, which their first call otherwise fetches. A failure is dropped; a
 * browser that keeps the failed import returns the same failure to that
 * first call.
 */
export const preloadPluginWebCode = (): void => {
  import('@capacitor-firebase/firestore/dist/esm/web').catch(() => undefined);
  import('@capacitor/device/dist/esm/web').catch(() => undefined);
  import('@capacitor-firebase/functions/dist/esm/web').catch(() => undefined);
};
